import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import InlineLink from '../inline-link';

const newline = () => (<br />);

const RenderMd = ({ source }) => (
  <ReactMarkdown
    source={source}
    renderers={{ link: InlineLink, break: newline }}
  />
);

RenderMd.propTypes = {
  source: PropTypes.string,
};

export default RenderMd;

